import { ResolveFn } from '@angular/router';

export const sliderSwiperResolver: ResolveFn<any> = () => {
  return [
    {
      href: '/coberturas-em-policarbonato/policarbonato-alveolar',
      imgDesktop:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-1.webp',
      imgMobile:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-1-mobile.webp',
      imgMobileBig:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-1-mobile-h.webp',
    },

    {
      href: '/kits/toldo-em-policarbonato',
      imgDesktop:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-3.webp',
      imgMobile:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-3-mobile.webp',
      imgMobileBig:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-3-mobile-h.webp',
    },

    {
      href: '/kits/policarbonato-alveolar-kit',
      imgDesktop:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-4.webp',
      imgMobile:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-4-mobile.webp',
      imgMobileBig:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-4-mobile-h.webp',
    },

    {
      href: '/toldos/toldos-cortina',
      imgDesktop:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-5.webp',
      imgMobile:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-5-mobile.webp',
      imgMobileBig:
        'https://d20p8exwoll05u.cloudfront.net/assets/images/slider/banner-5-mobile-h.webp',
    },
  ];
};
